import styled from 'styled-components';

import { ReactComponent as SVG } from 'assets/emptyDeleted.svg';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Image = styled(SVG)`
  width: 40rem;
  height: 40rem;
`;

export { Container, Image };
